import { html, css } from 'lit-element';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { BaseElement } from './BaseElement';
import { API, AuthServiceLoginError, ERROR_PASSWORD_MUST_CHANGE } from '../API';
import { DIALOG_TYPES } from './ModalDialog';
import { Router, PUSH_STATE } from '../Router';

const _api = Symbol();
const _router = Symbol();

export class QuickLogin extends BaseElement {
	constructor() {
		super();

		this.library.add(faSignInAlt);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {

				}
				input {
					width: 10em;
					margin-right: 0.25em;
					margin-bottom: 0.25em;
				}
				a {
					font-size: 0.85em;
				}
			`
		];
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.emit('get-router', { callback: router => this.router = router });
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api = null;
		this.router = null;
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get router() {
		return this[_router];
	}
	set router(v) {
		if(v !== null && !(v instanceof Router))
			throw new TypeError('router must be an instance of Router.');
		this[_router] = v;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();

			const detail = Object.fromEntries(new FormData(e.target));
			const { username, password } = detail;
			e.target.reset();
			// e.target.disabled = true;
			await this.api.login(username, password);
		}
		catch(err) {
			if(err instanceof AuthServiceLoginError && err.errorCode === ERROR_PASSWORD_MUST_CHANGE)
				this.router.go('/change-password', PUSH_STATE, '/change-password');
			this.emit('show-dialog', {
				title: 'Login Error',
				message: err instanceof TypeError ? 'Failed to connect to authentication service.' : err.message,
				type: DIALOG_TYPES.DIALOG_TYPE_ERROR
			});
		}
	}
	render() {
		return html`
			<form @submit="${(e) => this.handleSubmit(e)}">
				<input type="text" name="username" placeholder="Username"/>
				<input type="password" placeholder="Password" name="password"/>
				<button type="submit">
					<i class="icon fas fa-sign-in-alt"></i>
					Sign In
				</button>
			</form>
			<div><a href="/forgot-password">Forgot your password?</a></div>
			
		`;
	}
}

customElements.define('pp-quick-login', QuickLogin);